var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx - menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2 12L7 16V13H16V11H7V8L2 12Z",
    fill: "#F31260"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.001 2.99808C11.8186 2.9948 10.6472 3.22619 9.55477 3.67884C8.46236 4.1315 7.47063 4.79642 6.63702 5.63508L8.05102 7.04908C9.37302 5.72708 11.131 4.99808 13.001 4.99808C14.871 4.99808 16.629 5.72708 17.951 7.04908C19.273 8.37108 20.002 10.1291 20.002 11.9991C20.002 13.8691 19.273 15.6271 17.951 16.9491C16.629 18.2711 14.871 19.0001 13.001 19.0001C11.131 19.0001 9.37302 18.2711 8.05102 16.9491L6.63702 18.3631C8.33602 20.0631 10.596 21.0001 13.001 21.0001C15.406 21.0001 17.666 20.0631 19.365 18.3631C21.065 16.6641 22.002 14.4041 22.002 11.9991C22.002 9.59408 21.065 7.33408 19.365 5.63508C18.5314 4.79642 17.5397 4.1315 16.4473 3.67884C15.3549 3.22619 14.1835 2.9948 13.001 2.99808Z",
    fill: "#F31260"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.20da3fd53530d84c7bd9e7bdaf060cd9.svg";
export { ForwardRef as ReactComponent };